<template>
  <div class="user-list">
    <div class="search-bar flex">
      <div class="left">
        <el-select v-model="searchParam.pay_type" placeholder="支付方式" clearable @clear="getList">
          <el-option label="支付宝" value="1"></el-option>
          <el-option label="微信" value="2"></el-option>
          <el-option label="对公打款" value="3"></el-option>
          <el-option label="线下支付" value="4"></el-option>
          <el-option label="免费" value="5"></el-option>
        </el-select>
        <el-date-picker
          v-model="dates"
          type="daterange"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="changeDate"
        >
        </el-date-picker>

        <el-input
          v-model="searchParam.keyword_search"
          placeholder="输入订单号 用户关键字搜索"
          clearable
          style="margin-left: 10px"
          @clear="getList"
        ></el-input>
        <el-button type="primary" @click="getList('clear')">查询</el-button>
        <el-button type="primary" @click="resetSearch">重置</el-button>
      </div>
      <div class="right">
        <el-button @click="exportOrder">订单导出</el-button>
      </div>
    </div>
    <el-tabs v-model="searchParam.order_state" type="card" @tab-click="getList">
      <el-tab-pane label="全部订单" name=" "></el-tab-pane>
      <el-tab-pane label="待付款" name="0"></el-tab-pane>

      <el-tab-pane label="已完成" name="1"></el-tab-pane>
    </el-tabs>
    <div class="table">
      <el-table v-loading="loading" :data="tableData" border style="width: 100%">
        <el-table-column prop="order_sn" label="订单编号" fixed="left" width="120px"> </el-table-column>
        <el-table-column prop="user_name" label="下单用户" width="120px"> </el-table-column>

        <el-table-column prop="pay_type" label="支付方式" width="120px">
          <template slot-scope="scope">
            {{ ["", "支付宝", "微信", "对公打款", "线下支付", "免费"][scope.row.pay_type] }}
          </template>
        </el-table-column>
        <el-table-column prop="order_money" label="金额" width="160"></el-table-column>
        <el-table-column prop="live_title" label="直播"> </el-table-column>
        <el-table-column prop="order_state_txt" label="订单状态">
          <!--  <template slot-scope="scope">
                        {{ ['待付款','已付款','上课中','已完成'][scope.row.order_state]||'已取消' }}
                    </template> -->
        </el-table-column>
        <el-table-column prop="create_time" label="下单时间"> </el-table-column>

        <el-table-column prop="order_remark" label="备注" width="160"> </el-table-column>
        <el-table-column label="操作" fixed="right" width="320">
          <template slot-scope="scope">
            <el-button class="mid-blue" @click="toDetail(scope.row)">查看详情</el-button>
            <el-button class="mid-blue" @click="addNote(scope.row)">填写备注</el-button>
            <el-button v-show="scope.row.order_state == 0" class="mid-blue" @click="subPay(scope.row)"
              >支付确认</el-button
            >
            <el-button
              v-if="scope.row.order_state != 6 && scope.row.pay_type != 5 && scope.row.order_money - 0 != 0"
              class="mid-red"
              @click="cancelOrdel(scope.row)"
              >取消订单</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="填写备注" :visible.sync="notebox" width="30%" center :before-close="closeNotebox">
        <el-input v-model="order_remark" type="textarea"></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeNotebox">取 消</el-button>
          <el-button type="primary" @click="confirmNote">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="取消订单" :visible.sync="cancelbox" width="30%" center :before-close="closeCancelbox">
        <div class="flex-row">
          <span><i style="color: red">*</i>取消原因</span><el-input v-model="cancel_mark" type="textarea"></el-input>
        </div>
        <div class="flex-row">
          <span><i style="color: red">*</i>退款金额</span><el-input v-model="cancel_price" type="text"></el-input>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="closeCancelbox">取 消</el-button>
          <el-button type="primary" @click="confirmCancel">确 定</el-button>
        </span>
      </el-dialog>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[10, 20, 60, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { payList, editPay, LiveOrderExport } from "@/api/live.js";
import { getTeacherList } from "@/api/teacher.js";
import { mixin } from "@/mixins/pagination.js";
export default {
  mixins: [mixin],
  data() {
    return {
      actrow: {},
      notebox: false,
      loading: false,
      cancelbox: false,
      order_remark: "",
      cancel_price: "",
      cancel_mark: "",
      teacherList: [],
      searchParam: {
        keyword_search: "",
        order_state: " ",
        start_time: "",
        end_time: "",
      },
      dates: [],
      tableData: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    resetSearch() {
      this.searchParam = { order_state: " " };
      this.dates = [];
      this.page_index = 1;
      this.getList();
    },
    changeDate(val) {
      if (Array.isArray(val)) {
        this.searchParam = {
          ...this.searchParam,
          start_time: val[0],
          end_time: val[1],
        };
      } else {
        this.searchParam = {
          ...this.searchParam,
          start_time: "",
          end_time: "",
        };
        this.getList();
      }
      console.log(val);
    },
    editPay(data) {
      editPay(data, this.actrow.order_id).then((res) => {
        if (res == true) {
          this.closeNotebox();
          this.closeCancelbox();
          this.actrow = {};
          this.getList();
          this.$message.success("成功");
        } else {
          this.$message.error("失败");
        }
      });
    },
    exportOrder() {
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
      };
      LiveOrderExport(param);
    },
    addNote(row) {
      this.actrow = row;
      this.notebox = true;
    },
    closeNotebox() {
      this.notebox = false;
      this.order_remark = "";
    },
    confirmNote() {
      this.editPay({
        operating_type: 1,
        order_remark: this.order_remark,
      });
    },
    subPay(row) {
      this.actrow = row;
      this.$confirm("确认该订单已支付？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.editPay({ operating_type: 2, pay_state: 1 });
        })
        .catch(() => {});
    },
    confirmCancel() {
      if (!this.cancel_mark) {
        this.$message.warning("请输入取消原因");
        return;
      }
      if (!this.cancel_price) {
        this.$message.warning("请输入取消金额");
        return;
      }
      if (!(this.cancel_price - 0 >= 0)) {
        this.$message.warning("退款金额需要大于0");
        return;
      }
      if (this.cancel_price - 0 > this.actrow.order_money - 0) {
        this.$message.warning("退款金额不能大于订单金额");
        return;
      }
      this.editPay({
        operating_type: 3,
        cancel_mark: this.cancel_mark,
        cancel_price: this.cancel_price,
      });
    },
    closeCancelbox() {
      this.cancelbox = false;
      this.cancel_mark = "";
      this.cancel_price = "";
    },
    cancelOrdel(row) {
      this.cancelbox = true;
      this.cancel_price = row.order_money - 0;
      this.actrow = row;
    },
    getTeacher(keyword_search) {
      getTeacherList({ keyword_search }).then((res) => {
        if (res.data instanceof Array) {
          this.teacherList = res.data;
        }
      });
    },
    toDetail(row) {
      console.log(row);
      this.$router.push({
        path: "/order-detail",
        query: row,
      });
    },

    setTop(row) {
      setTopLive(row.uuid).then((res) => {
        if (res) {
          this.$message.success("成功");
          this.getList();
        }
      });
    },
    xiajia(row) {
      LiveStatus(row.uuid).then((res) => {
        if (res) {
          this.$message.success("成功");
          this.getList();
        }
      });
    },
    deleteItem(row) {
      this.$confirm("确定要删除该直播吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteLive(row.uuid).then((res) => {
            if (res) {
              this.$message.success("成功");
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async getList() {
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
      };
      this.loading = true;
      const res = await payList(param);
      this.loading = false;
      if (res.data instanceof Array) {
        this.tableData = res.data;
        this.total = res.total;
      }
    },
  },
};
</script>

<style scoped="scoped" lang="less">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
.flex-row {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  span {
    white-space: nowrap;
    margin-right: 20px;
  }
}
</style>
